import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs';
import { CartProductModel, CheckoutOrderModel, CheckoutOrderResponseModel, CheckoutViewModel } from '../models/checkout';
import { PerfilService } from './perfil.service';
import { EncryptionService } from './encryption.service';
import { StorageKeys } from '../models/storageKeys';

@Injectable({
    providedIn: 'root',
})

export class CheckoutService{
    route = new ApiConfiguration();
    ApiGetCheckoutViewModelPath = this.route.rootUrl + '/api/Checkout/get-checkout-view-model';
    ApiCrudCartProductPath = this.route.rootUrl + '/api/Checkout/crud-cart-product';
    ApiExecuteCheckoutPath = this.route.rootUrl + '/api/Checkout/execute-checkout';
    ApiCartProductsPath = this.route.rootUrl + '/api/Checkout/return-cart-products';
    ApiGetClientPoints = this.route.rootUrl + '/api/Checkout/get-client-points';
    ApiExecuteCheckoutExcelPath = this.route.rootUrl + '/api/Checkout/execute-checkout-excel';
    ApiIsSubClient = this.route.rootUrl + '/api/Checkout/is-sub-client';
    ApiNotifySuperClient = this.route.rootUrl + '/api/Checkout/notify-super-client';
    ApiSaveCheckoutObservation = this.route.rootUrl + '/api/Checkout/save-observation';
    ApiUserCheckoutObservation = this.route.rootUrl + '/api/Checkout/user-checkout-observation';

    constructor(
        private http: HttpClient, 
        private authService: AuthService, 
        private perfilService: PerfilService, 
        private encrypt: EncryptionService
    ) {}

    GetCheckoutViewModel(clientId: string) : Observable<CheckoutViewModel>{
        let userInfo = this.perfilService.getCurrentUserInfo();
        let subClientUsername = this.encrypt.getDecryptedItem(StorageKeys.BIO2_CLIENT_USERNAME)!;

        let accessToken = localStorage.getItem('BIO2_AccessToken');
        let tokenData = this.authService.getDecodedAccessToken(accessToken!);
        let userId = tokenData['registoId'];
        let endpoint = `${this.ApiGetCheckoutViewModelPath}/${userId}/${clientId}/${userInfo.role}/${subClientUsername}`;
        
        let headers = new HttpHeaders({
            Authorization: 'Bearer '+accessToken
        });
        return this.http.get<CheckoutViewModel>(endpoint,{headers:headers});
    }

    ExecuteCheckout(searchParameters: CheckoutOrderModel): Observable<CheckoutOrderResponseModel[]> {
        let userInfo = this.perfilService.getCurrentUserInfo();
        let subClientUsername = this.encrypt.getDecryptedItem(StorageKeys.BIO2_CLIENT_USERNAME)!;

        let accessToken = localStorage.getItem('BIO2_AccessToken');
        let tokenData = this.authService.getDecodedAccessToken(accessToken!);
        let userId = tokenData['registoId'];
    
        searchParameters.UserId = userId;
        searchParameters.UserRole = userInfo.role;
        searchParameters.SubClientUsername = subClientUsername;
    
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
        });
    
        return this.http.post<CheckoutOrderResponseModel[]>(this.ApiExecuteCheckoutPath, searchParameters, { headers: headers });
    }

    ExecuteCheckoutExcel(searchParameters: CheckoutOrderModel): Observable<CheckoutOrderResponseModel[]> {
        let accessToken = localStorage.getItem('BIO2_AccessToken');
        let tokenData = this.authService.getDecodedAccessToken(accessToken!);
        let userId = tokenData['registoId'];
    
        searchParameters.UserId = userId;
    
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
        });
    
        return this.http.post<CheckoutOrderResponseModel[]>(this.ApiExecuteCheckoutExcelPath, searchParameters, { headers: headers });
    }
    

    CrudCartProduct(searchParameters : CartProductModel) : Observable<boolean>{
        let userInfo = this.perfilService.getCurrentUserInfo();
        let subClientUsername = this.encrypt.getDecryptedItem(StorageKeys.BIO2_CLIENT_USERNAME)!;

        let accessToken = localStorage.getItem('BIO2_AccessToken');
        let tokenData = this.authService.getDecodedAccessToken(accessToken!);
        
        let endpoint = `${this.ApiCrudCartProductPath}`;
        if(searchParameters.userId == ''){
            let userId = tokenData['registoId'];
            searchParameters.userId = userId;
        }

        searchParameters.UserRole = userInfo.role;
        searchParameters.SubClientUsername = subClientUsername;

        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json', // Set the content type to JSON
        });

        return this.http.post<boolean>(endpoint, searchParameters, {headers:headers});
    }

    getUserCart(user: string, clientId: string): Observable<CartProductModel[]> {
        let userInfo = this.perfilService.getCurrentUserInfo();
        let subClientUsername = this.encrypt.getDecryptedItem(StorageKeys.BIO2_CLIENT_USERNAME)!;
        
        let params = new HttpParams();
        params = params.append('userId', String(user));
        params = params.append('clientId', String(clientId));
        params = params.append('userRole', String(userInfo.role));
        params = params.append('subClientUsername', String(subClientUsername));
        let endpoint = `${this.ApiCartProductsPath}/${user}/${clientId}/${userInfo.role}/${subClientUsername}`;
        return this.http.get<CartProductModel[]>(endpoint)
    }

    getClientPoints(user:string, clientId: string): Observable<number>{
        let params = new HttpParams();
        params = params.append('userId', String(user));
        params = params.append('clientId', String(clientId));
        let endpoint = `${this.ApiGetClientPoints}/${user}/${clientId}`;
        return this.http.get<number>(endpoint);
    }

    isSubClient(username:string): Observable<number>{
        let endpoint = `${this.ApiIsSubClient}/${username}`;
        return this.http.get<number>(endpoint);
    }

    notifySuperClient(username: string): Observable<boolean> {
        let endpoint = `${this.ApiNotifySuperClient}?username=${encodeURIComponent(username)}`;
        return this.http.post<boolean>(endpoint, {});
    }

    saveCheckoutObservation(username: string, observation: string, clientId?: string): Observable<boolean> {
        if (!clientId) {
            let subClientUsername = this.encrypt.getDecryptedItem(StorageKeys.BIO2_CLIENT_USERNAME)!;

            if(subClientUsername)
                username=subClientUsername
    }

        const endpoint = this.ApiSaveCheckoutObservation;
        const body: { username: string; observation: string; clientId?: string } = {
            username: username,
            observation: observation
        };

        if (clientId) {
            body.clientId = clientId;
        }

        return this.http.post<boolean>(endpoint, body);
    }

    getUserCheckoutObservation(username: string, clientId?: string): Observable<string> {
        if (!clientId) {
            let subClientUsername = this.encrypt.getDecryptedItem(StorageKeys.BIO2_CLIENT_USERNAME)!;

            if(subClientUsername)
                username=subClientUsername
        }

        let endpoint = `${this.ApiUserCheckoutObservation}?username=${encodeURIComponent(username)}`;

        if (clientId) {
            endpoint += `&clientId=${encodeURIComponent(clientId)}`;
        }

        return this.http.get(endpoint, { responseType: 'text' });
    }

}